import { render, staticRenderFns } from "./TestList.vue?vue&type=template&id=1641d0ba&"
import script from "./TestList.vue?vue&type=script&lang=ts&"
export * from "./TestList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports